// Shell/Sidebar (Figma 18:11) — 240px, its nav's destinations, an optional
// pinned row at the foot above the account row. PRD 18 US-011.
//
// Takes a ShellNav rather than an org slug so the operator console draws
// through the same chassis. See `hrefs.ts` for why that is one type and not a
// second shell component.

import { Link, useRouterState } from "@tanstack/react-router";
import { activeNavKey } from "./hrefs";
import type { NavDestination, ShellNav } from "./hrefs";

export function Sidebar({ nav }: { nav: ShellNav }) {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const active = activeNavKey(pathname, nav);

  return (
    <nav className="maisight-shell-sidebar" aria-label="Primary">
      <div className="maisight-shell-brand type-label">
        <span className="maisight-shell-lamp" aria-hidden="true" />
        mAiSight
      </div>
      <div className="maisight-shell-section-label type-labelSm">{nav.section}</div>
      <div className="maisight-shell-nav">
        {nav.items.map((item) => (
          <NavItem key={item.key} item={item} isActive={item.key === active} />
        ))}
      </div>
      <div className="maisight-shell-spacer" />
      {nav.pinned ? (
        <div className="maisight-shell-nav">
          <NavItem item={nav.pinned} isActive={nav.pinned.key === active} />
        </div>
      ) : null}
      <div className="maisight-shell-account type-numSm">
        <span className="maisight-shell-avatar" aria-hidden="true">
          {nav.identity.slice(0, 2).toUpperCase()}
        </span>
        <span>{nav.identity}</span>
      </div>
    </nav>
  );
}

function NavItem({ item, isActive }: { item: NavDestination; isActive: boolean }) {
  return (
    <Link
      to={item.href}
      className="maisight-shell-nav-item type-label"
      data-nav={item.key}
      aria-current={isActive ? "page" : undefined}
    >
      {item.label}
    </Link>
  );
}
